import { ElementAttribute } from "../../dom-tools/ElementAttribute";
import { ElementType } from "../../dom-tools/ElementType";
import { SourceRange } from "../../text/lexer/parsing/SourceInfo";
import { RJParser } from "../RJParser";
import { RJExpressionNode } from "./RJExpressionNode";
import { RJExpressionNodeType } from "./RJExpressionNodeType";
import { RJToken } from "./RJToken";


export class UnaryExpression extends RJExpressionNode
{
  operatorToken:RJToken;
  _expression:RJExpressionNode;
  _isPost:boolean = true;

  constructor( parser:RJParser, range:SourceRange = null, isPost:boolean )
  {
    super( parser, RJExpressionNodeType.UNARY, range );
    this._isPost = isPost;
  }

  setExpression( operatorToken:RJToken, expression:RJExpressionNode )
  {
    this.operatorToken = operatorToken;
    this._expression = expression;
    this._expression._setParent( this );

    this._children = this._isPost ? [ expression, operatorToken ] : [ operatorToken, expression ];

    this.operatorToken._setParent( this );
    this._expression._setParent( this );
  }

  cloneNode():UnaryExpression
  {
    let clone = new UnaryExpression( this.parser, this.sourceRange, this._isPost );
    clone.setExpression( this.operatorToken.cloneNode(), this._expression.cloneNode() );
    return clone;
  }

  static readonly operatorAttribute = new ElementAttribute( "operator-token" );

  createHTMLElement():Element
  {   
    let element = this._createRawHTMLElement();

    UnaryExpression.operatorAttribute.to( element, this.operatorToken.match );

    let unaryExpressionElement  = new ElementType( "rj-unary-expression" ).create( this._expression.createHTMLElement() );

    element.appendChild( unaryExpressionElement );

    return element;
  }
}